import React from "react";
import WorkPic from "../Assets/works.png";
import Merita from "../Assets/merita.jpg";
import Vinova from "../Assets/vinova.jpg";
import Bonusrun from "../Assets/bonusrun.jpg";

function Works() {
    return (
        <nav>
            <h3 className="text-[3rem] sm:text-[4rem] md:text-left text-center">Works</h3>
            <div className="work-grid items-stretch mx-auto">
                <p className=" text-[2rem] leading-[2.8rem] col-span-full row-span-1 w-[auto]  mx-auto">
                    Here you can check some of our works that we are proud of.
                    We participated in their development, design and also their
                    branding
                </p>
                <p className="sm:col-span-4 col-span-full  row-span-1 sm:row-span-2 text-[2rem] justify-self-center self-center leading-[2.8rem] w-full">
                    these three project we have here, are some of our works that
                    we are proud of. You can visit any of them by clicking on
                    their picture. Go on and check them out.
                </p>
                <div className="sm:col-span-5 col-span-full w-full justify-self-center row-span-2 md:row-span-2 lg:row-span-3 relative work-card">
                    <a target="_blank" href="https://mymerita.com/">
                        <img src={Merita} className="h-full w-full" alt="" />
                        <div className=" absolute top-0 w-full h-1/4 bg-pink px-9 py-5 work-card-detail opacity-0">
                            <h4 className="text-[1.6rem] font-bold">
                                Obotp website design
                            </h4>
                            <p className="text-[1.2rem] mt-5">
                                We love integrating with product teams and
                                balancing the fun yet
                            </p>
                        </div>
                    </a>
                </div>
                <div className="sm:col-span-4 col-span-full w-full justify-self-center row-span-2 md:row-span-2 lg:row-span-3  relative work-card">
                    <a target="_blank" href="https://vinova.agency/">
                        <img src={Vinova} className="h-full w-full" alt="" />
                        <div className=" absolute top-0 w-full h-1/4 bg-blue px-9 py-5 work-card-detail opacity-0">
                            <h4 className="text-[1.6rem] font-bold">
                                Obotp website design
                            </h4>
                            <p className="text-[1.2rem] mt-5">
                                We love integrating with product teams and
                                balancing the fun yet
                            </p>
                        </div>
                    </a>
                </div>
                <div className="sm:col-span-5 col-span-full justify-self-center row-span-2 relative work-card w-full">
                    <a target="_blank" href="https://www.bonusrun.com/">
                        <img src={Bonusrun} className="h-full w-full" alt="" />
                        <div className=" absolute top-0 w-full h-2/5 bg-purple px-9 py-5 text-white work-card-detail opacity-0">
                            <h4 className="text-[1.6rem] font-bold">
                                Obotp website design
                            </h4>
                            <p className="text-[1.2rem] mt-5">
                                We love integrating with product teams and
                                balancing the fun yet
                            </p>
                        </div>
                    </a>
                </div>
                <div className="sm:col-span-4 col-span-full justify-self-center row-span-2 relative work-card flex items-center justify-center text-center border border-purple rounded-3xl">
                    {/* <div className=" absolute top-0 w-full h-2/5 px-9 py-5 flex items-center justify-center text-center"> */}
                    <h3 className="smallest-screen:text-[3rem] small-screen:text-[3.5rem] sm:text-[5rem] work-title px-16">
                        Your Project Will Be Here!
                    </h3>
                    {/* </div> */}
                </div>

                <p className=" text-[2rem] leading-[2.8rem] sm:col-span-4 col-span-full row-span-2 self-center">
                    Why your project can't be the next project that we are going
                    to put here with pride? Contact us so we can give it chance!
                    It would be totally free to have consult session with each
                    other.
                </p>
            </div>
        </nav>
    );
}

export default Works;
